<template>
	<div>
		<GTreeView
			placeholder="Rechercher un client"
			:multiple="false"
			v-on:update:selected="data => $emit('selection', data)"
			:load-options="loadUsers"
			:async="true" />
	</div>
</template>
<script>
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';
	export default {
		name: 'find-customer',

		components: { GTreeView },

		methods: {
			loadUsers({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);
					params.append('type', 'sender');

					this.$axios.get(`/api/addresses?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = `${item.owner.email} - ${item.lastName} ${item.firstName} - ${item.postalCode} ${item.city}`;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						callback(null, options);
					});
				}
			},
		},
	};
</script>
